import { TransferType } from '@app/common/types/enum/transferType';

import { getFixedT } from '@app/core/i18n';

const t = getFixedT(null, null);

export const TransferTypeTranslation = {
  [TransferType.SEND_NOW]: t(
    'transfer-type.send-now|Label for "Send now"',
    'Now',
  ),
  [TransferType.SAME_DAY]: t(
    'transfer-type.same-day|Label for "Same day',
    'Same day',
  ),
  [TransferType.ONE_TIME]: t(
    'transfer-type.one-time|Label for "One time"',
    'Later',
  ),
  [TransferType.DAILY]: t(
    'transfer-type.daily|Label for "Daily"',
    'Daily',
  ),
  [TransferType.WEEKLY]: t(
    'transfer-type.weekly|Label for "Weekly"',
    'Weekly',
  ),
  [TransferType.EVERY_TWO_WEEKS]: t(
    'transfer-type.every-two-weeks|Label for "Every two weeks"',
    'Every two weeks',
  ),
  [TransferType.SEMI_MONTHLY]: t(
    'transfer-type.semi-monthly|Label for "Semimonthly"',
    'Semimonthly',
  ),
  [TransferType.MONTHLY]: t(
    'transfer-type.monthly|Label for "Monthly"',
    'Monthly',
  ),
  [TransferType.EVERY_THREE_MONTHS]: t(
    'transfer-type.every-three-months|Label for "Every three months"',
    'Every three months',
  ),
  [TransferType.EVERY_SIX_MONTHS]: t(
    'transfer-type.every-six-months|Label for "Every six months"',
    'Every six months',
  ),
  [TransferType.ANNUALLY]: t(
    'transfer-type.annually|Label for "Annually"',
    'Annually',
  ),
  [TransferType.LOAN_ON_DUE_DATE]: t(
    'transfer-type.loan-on-due-date|Label for "Recurring automatic payments"',
    'Recurring automatic payments',
  ),
  [TransferType.WEEK_OF_MONTH]: t(
    'transfer-type.week-on-month|Label for "week of month"',
    'Monthly',
  ),
  [TransferType.LEGACY_WEEKLY]: t(
    'transfer-type.legacy-weekly|Label for "Weekly"',
    'Weekly',
  ),
  [TransferType.LEGACY_MONTHLY]: t(
    'transfer-type.legacy-montly|Label for "Monthly"',
    'Monthly',
  ),
  [TransferType.LEGACY_DAILY]: t(
    'transfer-type.legacy-daily|Label for "Daily"',
    'Daily',
  ),
  [TransferType.LEGACY_ANNUALLY]: t(
    'transfer-type.legacy-annually|Label for "Annually"',
    'Annually',
  ),
};
